// extracted by mini-css-extract-plugin
module.exports = {"results":"IndividualEmployeeResults_results_5WAXg","header":"IndividualEmployeeResults_header_1kWJH","result":"IndividualEmployeeResults_result_1LMkS"};